//Curve background animation on scroll
const config = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

//Animate all curve backgrounds on scroll
const observer = new IntersectionObserver(entries => {
    // Loop over the entries
    entries.forEach(entry => {
      // If the element is visible
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        console.log('animate');
        const path = entry.target.querySelector('path');
        // Add the animation class
        path.classList.add('animate--dash');
      }
    });
  }, config);
  
const curveBgs = document.querySelectorAll('.collection-curve-bg');

curveBgs.forEach((element) => observer.observe(element));



document.addEventListener('DOMContentLoaded', () => {
  //Header scroll related
  const header_wrapper = document.querySelector('.header-wrapper');
  const header = document.querySelector('.header');
  const trustpilot_bar = document.querySelector('.trustpilot-bar');

  // window.addEventListener('scroll', () => {
  //   if (window.scrollY > 10) {
  //     header_wrapper.classList.add('scrolled');
  //     header.classList.add('scrolled');
  //     trustpilot_bar.classList.add('scrolled');
  //   } else {
  //     header_wrapper.classList.remove('scrolled');
  //     header.classList.remove('scrolled');
  //     trustpilot_bar.classList.remove('scrolled');
  //   }
  // });


  //Footer collapse
  const menu_buttons = document.querySelectorAll('.menu-button');
  menu_buttons.forEach((button) => {
    const target_menu_list = button.parentElement.querySelector('.menu-wrapper');
    const menu_list = target_menu_list.querySelector('ul');
    if (target_menu_list) {
      //Inital setup
      target_menu_list.style.height = `${menu_list.offsetHeight}px`
      
      button.addEventListener('click', () => {
        if (target_menu_list.classList.contains('collapsed')) {
          button.classList.remove('active');
          target_menu_list.classList.remove('collapsed');
          target_menu_list.style.height = `${menu_list.offsetHeight}px`
        } else {
          button.classList.add('active');
          target_menu_list.classList.add('collapsed');
          target_menu_list.style.height = '0px';
        }
    });
    }
  });


  //Product collapse
  const product_buttons = document.querySelectorAll('.product__details-collapsable-mobile-button');
  product_buttons.forEach((button) => {
    const target_product_details = button.parentElement.querySelector('.product__details-collapsable-mobile');
    const product_details_content = target_product_details.querySelector('.product__details-collapsable-mobile-content');
    const button_text = button.querySelector('p');
    if (target_product_details) {
      button.addEventListener('click', () => {
        if (button.classList.contains('collapsed')) {
          button.classList.remove('collapsed');
          target_product_details.classList.remove('collapsed');
          target_product_details.style.height = `${product_details_content.offsetHeight}px`;
          button_text.textContent = 'Less';
        } else {
          button.classList.add('collapsed');
          target_product_details.classList.add('collapsed');
          target_product_details.style.height = '0px';
          button_text.textContent = 'More';
        }
      });
    }
  })

  //FAQ accordions
});